import React from 'react';
import { useReveal } from '../shell';
import { aboutFacts, skillGroups, timeline } from '../data';

const About = () => {
  useReveal([]);

  return (
    <>
      <section className="m-about">
        <div>
          <div className="m-head__kicker">About</div>
          <h1 className="m-head__title">
            The mission,
            <br />
            plainly stated
          </h1>
          <p className="m-head__lead" style={{ maxWidth: '58ch' }}>
            B.Tech Computer Science from Graphic Era Hill University. I build things that ship —
            machine-learning models, full-stack web apps, Android and desktop utilities — and I
            keep learning at the same rate I keep shipping.
          </p>
        </div>

        <div className="m-facts">
          {aboutFacts.map((f) => (
            <div key={f.k} className="m-fact">
              <div className="m-fact__value">{f.v}</div>
              <div className="m-fact__label">{f.k}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="m-section">
        <h2 className="m-split__title">Journey</h2>
        <div className="m-grid3">
          {timeline.map((t) => (
            <div key={t.title} className="m-cell m-reveal">
              <div className="m-cell__date">
                {t.period} · {t.metric}
              </div>
              <h3 className="m-cell__title">{t.title}</h3>
              <div className="m-cell__org">{t.org}</div>
              <p className="m-cell__body">{t.body}</p>
              <div className="m-tags">
                {t.tags.map((tag) => (
                  <span key={tag} className="m-tag m-tag--outline">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="m-section" style={{ borderBottom: 0 }}>
        <h2 className="m-split__title">Arsenal of technologies</h2>
        <div className="m-grid3">
          {skillGroups.map((g) => (
            <div key={g.title} className="m-cell m-reveal">
              <h3 className="m-skillgroup__title">{g.title}</h3>
              {g.items.map((s) => (
                <div key={s.name} className="m-skill">
                  <div className="m-skill__head">
                    <span>{s.name}</span>
                    <span style={{ color: 'var(--color-neutral-700)' }}>{s.pct}%</span>
                  </div>
                  <div
                    className="m-skill__track"
                    role="meter"
                    aria-valuenow={s.pct}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-label={s.name}
                  >
                    <div className="m-skill__fill" style={{ width: `${s.pct}%` }} />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default About;
